module.exports = __webpack_public_path__ + "images/feature/data-export-3-11a7f37463610a75c593227f592a2ac5.png";